import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';

import { environment } from '../../../environments/environment';
import { AuthService } from './auth.service';
import {
  IRole,
  IArticle,
  IArticleOption,
  IArticleOptionPrice,
  IArticleOptionType,
  IArticlePrice,
  IDiscountCode,
  IOrderSearch,
  IUpload, IUserEdit
} from './api-lavandier.service.type';
import { IAddressOrder, IOrderBag } from './api.service.type';
import { StringPage } from '../utils/Page';
import { PaymentType } from '../../lib-shared/types/PaymentType';
import { ConfigInvoiceTemplate } from '../../lib-shared/types/ConfigInvoiceTemplate';
import { EventConfigType } from '../../lib-shared/types/EventConfigType';
import { EventConfigEvent } from '../../lib-shared/types/EventConfigEvent';
import { OrderArticleTrackingDefectStation } from '../../lib-shared/types/OrderArticleTrackingDefectStation';
import { OrderArticleTrackingDefectType } from '../../lib-shared/types/OrderArticleTrackingDefectType';
import { ArticleFamilyType } from '../../lib-shared/types/ArticleFamilyType';
import { LightState } from '../../lib-shared/types/LightState';
import { AddressField, getAddressField } from '../utils/AddressField';
import {
  TTransportSheetGetRefDetailsRep,
  ITransportSheetGetRefDetailsReq,
  TTransportSheetPutIdFactoryReceivedRep,
  TTransportSheetPutIdFactoryReceivedReq,
  TTransportSheetPutIdFactorySentRep,
  TTransportSheetPutIdFactorySentReq, ITransportSheetGetIdRePrintReq, TTransportSheetGetIdRePrintRep, TTransportSheetGetUserIdRep, TTransportSheetGetUserIdReq, ITransportSheetPutUserIdBookReq, TTransportSheetPutUserIdBookRep,
  ITransportSheetPutIdHouseReq,
  TTransportSheetPutIdHouseRep,
  ITransportSheetPutIdDisableReq,
  TTransportSheetPutIdDisableRep
} from '../../lib-shared/api/lavandier/TransportSheet.Type';
import {
  TOrderBagGetTransportSheetRefDetailsRep,
  IOrderBagGetTransportSheetRefDetailsReq, IOrderBagGetNotEmptyDetailsReq, TOrderBagGetNotEmptyDetailsRep
} from '../../lib-shared/api/lavandier/OrderBag.Type';
import {
  IOrderGetIdDetailsReq, IOrderGetIdOrderArticleTrackingReq,
  IOrderGetKitBatchReq, IOrderGetKitReq, IOrderGetReadyToShipReq,
  IOrderPostKitReq,
  IOrderPutIdKitBatchReq, IOrderPutIdCancelReq, IOrderPutIdKitReq, TOrderGetIdDetailsRep, TOrderGetIdOrderArticleTrackingRep,
  TOrderGetKitBatchRep, TOrderGetKitRep, TOrderGetReadyToShipRep,
  TOrderPostKitRep,
  TOrderPutIdKitBatchRep, TOrderPutIdCancelRep, TOrderPutIdKitRep,
  IOrderGetUserIdHouseNameReq, TOrderGetUserIdHouseNameRep,
  IOrderGetUserIdReq, TOrderGetUserIdRep,
  IOrderGetReq, TOrderGetRep,
  IOrderPutIdTransportSheetReq, TOrderPutIdTransportSheetRep, IOrderGetOrderArticleTrackingRefRefDetailsReq, TOrderGetOrderArticleTrackingRefRefDetailsRep,
} from '../../lib-shared/api/lavandier/Order.Type';
import { ShippingPriceType } from '../../lib-shared/types/ShippingPriceType';
import { IOrderShipReturnGetReadyToShipReq, IOrderShipReturnGetReadyToValidateReq, IOrderShipReturnPutIdShipReq, IOrderShipReturnPutIdValidateReq, TOrderShipReturnGetReadyToShipRep, TOrderShipReturnGetReadyToValidateRep, TOrderShipReturnPutIdShipRep, TOrderShipReturnPutIdValidateRep } from '../../lib-shared/api/lavandier/OrderShipReturn.Type';
import { CalendarDayType } from '../../lib-shared/types/CalendarDayType';
import { IHouseDeleteIdReq, IHouseGetUserIdReq, IHousePostReq, IHousePutIdDefaultReq, IHousePutIdReq, THouseDeleteIdRep, THouseGetUserIdRep, THousePostRep, THousePutIdDefaultRep, THousePutIdRep } from '../../lib-shared/api/lavandier/House.Type';
import { ILightGetBridgeReq, ILightGetDetailsReq, ILightGetReq, ILightPutIdReq, TLightGetBridgeRep, TLightGetDetailsRep, TLightGetRep, TLightPutIdRep } from '../../lib-shared/api/lavandier/Light.Type';
import { IStorageGetReq, IStoragePutReq, TStorageGetRep, TStoragePutRep } from '../../lib-shared/api/lavandier/Storage.Type';
import { ILavandierGetReq, ILavandierPostReq, ILavandierPutReq, TLavandierGetRep, TLavandierPostRep, TLavandierPutRep } from '../../lib-shared/api/lavandier/Lavandier.Type';
import { IUserDeleteIdReq, IUserGetIntercomRedirectByUserIdReq, IUserGetTypeReq, IUserPostReq, TUserDeleteIdRep, TUserGetIntercomRedirectByUserIdRep, TUserGetTypeRep, TUserPostRep, IUserPutIdForgottenPasswordReq, TUserPutIdForgottenPasswordRep, IUserPutIdAnonymiseCancelReq, TUserPutIdAnonymiseCancelRep } from '../../lib-shared/api/lavandier/User.Type';
import { IDiscountCodeGetIdReq, TDiscountCodeGetIdRep } from '../../lib-shared/api/lavandier/DIscountCode.Type';
import { IOrderArticleTrackingGetRefRefDetailsReq, IOrderArticleTrackingPutIdDefectReq, IOrderArticleTrackingPutIdFactoryReq, IOrderArticleTrackingPutIdTidiedReq, IOrderArticleTrackingPutIdUnTidiedReq, IOrderArticleTrackingPutStorageRefReq, TOrderArticleTrackingGetRefRefDetailsRep, TOrderArticleTrackingPutIdDefectRep, TOrderArticleTrackingPutIdFactoryRep, TOrderArticleTrackingPutIdTidiedRep, TOrderArticleTrackingPutIdUnTidiedRep, TOrderArticleTrackingPutStorageRefRep, IOrderArticleTrackingPutDefectIdCloseReq, TOrderArticleTrackingPutDefectIdCloseRep } from '../../lib-shared/api/lavandier/OrderArticleTracking.Type';
import { ICreditPostReq, TCreditPostRep } from '../../lib-shared/api/lavandier/Credit.Type';
import { ICreditDeleteIdReq, ICreditPutIdReq, TCreditDeleteIdRep, TCreditPutIdRep } from '../../lib-shared/api/lavandier/Credit.Type';
import {
  IArticlePackDeleteIdReq, IArticlePackGetReq, IArticlePackPostReq, IArticlePackPutIdReq,
  TArticlePackDeleteIdRep, TArticlePackGetRep, TArticlePackPostRep, TArticlePackPutIdRep
} from '../../lib-shared/api/lavandier/ArticlePack.Type';

@Injectable({
  providedIn: 'root'
})
export class ApiLavandierService {
  private url = ApiLavandierService.generateUrl(environment.api_url);

  constructor(
    private authService: AuthService,
    private http: HttpClient
  ) {
  }

  static generateUrl(base: string) {
    return `${base}/lavandier`;
  }

  setUrl(base: string) {
    this.url = ApiLavandierService.generateUrl(base);
  }

  postAccount(params: { userTypeId: number, name: string, address: { firstName: string, lastName: string, streetNumber: string, route: string, locality: string, country: string, postalCode: string, formattedAddress: string, lat: number, lng: number, phoneNumber: string, additional: string } }) {
    return this.http.post(`${this.url}/account`, params, this.authService.getHttpOptions());
  }

  putAccount(id: number, params: { name: string, address: { firstName: string, lastName: string, streetNumber: string, route: string, locality: string, country: string, postalCode: string, formattedAddress: string, lat: number, lng: number, phoneNumber: string, additional: string } }) {
    return this.http.put(`${this.url}/account/${id}`, params, this.authService.getHttpOptions());
  }

  getAccountDetails(id: number) {
    return this.http.get(`${this.url}/account/${id}/details`, this.authService.getHttpOptions());
  }

  postArticleFamily(params: { userTypeIdList: number[], weight: number, type: ArticleFamilyType, name: string, color: string }) {
    return this.http.post(`${this.url}/article/family`, params, this.authService.getHttpOptions());
  }

  postArticleOptionPrice(articleOptionPrice: IArticleOptionPrice) {
    return this.http.post(`${this.url}/article/option/price`, articleOptionPrice, this.authService.getHttpOptions());
  }

  postArticleOptionType(articleOptionType: IArticleOptionType) {
    return this.http.post(`${this.url}/article/option/type`, articleOptionType, this.authService.getHttpOptions());
  }

  postArticleOption(articleOption: IArticleOption) {
    return this.http.post(`${this.url}/article/option`, articleOption, this.authService.getHttpOptions());
  }

  postArticlePrice(articlePrice: IArticlePrice) {
    return this.http.post(`${this.url}/article/price`, articlePrice, this.authService.getHttpOptions());
  }

  postArticle(article: IArticle) {
    return this.http.post(`${this.url}/article`, article, this.authService.getHttpOptions());
  }

  putArticleFamily(articleFamilyId: number, params: { userTypeIdList: number[], weight: number, type: ArticleFamilyType, name: string, color: string }) {
    return this.http.put(`${this.url}/article/family/${articleFamilyId}`, params, this.authService.getHttpOptions());
  }

  putArticleOptionPrice(articleOptionPriceId: number, articleOptionPrice: IArticleOptionPrice) {
    return this.http.put(`${this.url}/article/option/price/${articleOptionPriceId}`, articleOptionPrice, this.authService.getHttpOptions());
  }

  putArticleOptionType(articleOptionTypeId: number, articleOptionType: IArticleOptionType) {
    return this.http.put(`${this.url}/article/option/type/${articleOptionTypeId}`, articleOptionType, this.authService.getHttpOptions());
  }

  putArticleOption(articleOptionId: number, articleOption: IArticleOption) {
    return this.http.put(`${this.url}/article/option/${articleOptionId}`, articleOption, this.authService.getHttpOptions());
  }

  putArticlePrice(articlePriceId: number, articlePrice: IArticlePrice) {
    return this.http.put(`${this.url}/article/price/${articlePriceId}`, articlePrice, this.authService.getHttpOptions());
  }

  putArticle(articleId: number, article: IArticle) {
    return this.http.put(`${this.url}/article/${articleId}`, article, this.authService.getHttpOptions());
  }

  getArticleFamilyList() {
    return this.http.get(`${this.url}/article/family`, this.authService.getHttpOptions());
  }

  getArticleOptionPublicList() {
    return this.http.get(`${this.url}/article/option/public`, this.authService.getHttpOptions());
  }

  getArticleOptionTypeList() {
    return this.http.get(`${this.url}/article/option/type`, this.authService.getHttpOptions());
  }

  getArticleOptionList() {
    return this.http.get(`${this.url}/article/option`, this.authService.getHttpOptions());
  }

  getArticle(articleId: number) {
    return this.http.get(`${this.url}/article/${articleId}`, this.authService.getHttpOptions());
  }

  getArticleList() {
    return this.http.get(`${this.url}/article`, this.authService.getHttpOptions());
  }

  deleteArticleOptionPrice(articleOptionPriceId: number) {
    return this.http.delete(`${this.url}/article/option/price/${articleOptionPriceId}`, this.authService.getHttpOptions());
  }

  deleteArticlePrice(articlePriceId: number) {
    return this.http.delete(`${this.url}/article/price/${articlePriceId}`, this.authService.getHttpOptions());
  }

  postArticlePack(params: IArticlePackPostReq) {
    return this.http.post<TArticlePackPostRep>(`${this.url}/articlepack`, params, this.authService.getHttpOptions());
  }

  putArticlePackId(id: number, params: IArticlePackPutIdReq) {
    return this.http.put<TArticlePackPutIdRep>(`${this.url}/articlepack/${id}`, params, this.authService.getHttpOptions());
  }

  getArticlePack(params: IArticlePackGetReq) {
    return this.http.get<TArticlePackGetRep>(`${this.url}/articlepack`, this.authService.getHttpOptions());
  }

  deleteArticlePackId(id: number, params: IArticlePackDeleteIdReq) {
    return this.http.delete<TArticlePackDeleteIdRep>(`${this.url}/articlepack/${id}`, this.authService.getHttpOptions());
  }

  postCalendarDay(params: { type: CalendarDayType, date: string }) {
    return this.http.post(`${this.url}/calendarday`, params, this.authService.getHttpOptions());
  }

  putCalendarDay(id: number, params: { type: CalendarDayType, date: string }) {
    return this.http.put(`${this.url}/calendarday/${id}`, params, this.authService.getHttpOptions());
  }

  getCalendarDayList() {
    return this.http.get(`${this.url}/calendarday`, this.authService.getHttpOptions());
  }

  postCredit(params: ICreditPostReq) {
    return this.http.post<TCreditPostRep>(`${this.url}/credit`, params, this.authService.getHttpOptions());
  }

  putCredit(id: number, params: ICreditPutIdReq) {
    return this.http.put<TCreditPutIdRep>(`${this.url}/credit/${id}`, params, this.authService.getHttpOptions());
  }

  getCreditUser(userId: number) {
    return this.http.get(`${this.url}/credit/user/${userId}`, this.authService.getHttpOptions());
  }

  deleteCredit(id: number, params: ICreditDeleteIdReq) {
    return this.http.delete<TCreditDeleteIdRep>(`${this.url}/credit/${id}`, this.authService.getHttpOptions());
  }

  postDiscountCode(discountCode: IDiscountCode) {
    return this.http.post(`${this.url}/discountCode`, discountCode, this.authService.getHttpOptions());
  }

  getDiscountCodeIsValid(params: { userId: string, code: string }) {
    return this.http.get(`${this.url}/discountCode/isvalid`, {
      headers: this.authService.getHttpHeaders(), params: new HttpParams({fromObject: params})
    });
  }

  getDiscountCode(id: number, params: IDiscountCodeGetIdReq) {
    return this.http.get<TDiscountCodeGetIdRep>(`${this.url}/discountCode/${id}`, this.authService.getHttpOptions());
  }

  getDiscountCodeList(page: StringPage) {
    return this.http.get(`${this.url}/discountCode`, {
      headers: this.authService.getHttpHeaders(), params: {...page}
    });
  }

  getDocArticleTrackingType(params: { orderId: string, 'refList[]': string[], 'nameList[]': string[], 'optionList[]': string[], type: 'png' | 'pdf' }) {
    return this.http.get(`${this.url}/doc/articletracking/${params.type}`, {
      headers: this.authService.getHttpHeaders(), responseType: 'blob',
      params: new HttpParams({fromObject: params})
    });
  }

  getDocTrackingSheetType(id: number, params: { type: 'png' | 'pdf' }) {
    return this.http.get(`${this.url}/doc/trackingsheet/${id}/${params.type}`, {
      headers: this.authService.getHttpHeaders(), responseType: 'blob'
    });
  }

  getDocQRCodeTokenType(id: number, params: { type: 'png' | 'pdf' }) {
    return this.http.get(`${this.url}/doc/qrcodetoken/${id}/${params.type}`, {
      headers: this.authService.getHttpHeaders(), responseType: 'blob'
    });
  }

  getDocInvoice(orderId: number) {
    return this.http.get(`${this.url}/doc/invoice/${orderId}`, {
      headers: this.authService.getHttpHeaders(), responseType: 'blob'
    });
  }

  postEventConfig(params: { configId: number, type: EventConfigType, event: EventConfigEvent, value: any }) {
    return this.http.post(`${this.url}/eventconfig`, params, this.authService.getHttpOptions());
  }

  putEventConfig(eventConfigId: number, params: { type: EventConfigType, event: EventConfigEvent, value: any }) {
    return this.http.put(`${this.url}/eventconfig/${eventConfigId}`, params, this.authService.getHttpOptions());
  }

  deleteEventConfig(eventConfigId: number) {
    return this.http.delete(`${this.url}/eventconfig/${eventConfigId}`, this.authService.getHttpOptions());
  }

  postHouse(params: IHousePostReq) {
    return this.http.post<THousePostRep>(`${this.url}/house`, params, this.authService.getHttpOptions());
  }

  putHouseIdDefault(id: number, params: IHousePutIdDefaultReq) {
    return this.http.put<THousePutIdDefaultRep>(`${this.url}/house/${id}/default`, params, this.authService.getHttpOptions());
  }

  putHouseId(houseId: number, params: IHousePutIdReq) {
    return this.http.put<THousePutIdRep>(`${this.url}/house/${houseId}`, params, this.authService.getHttpOptions());
  }

  getHouseUserId(userId: number, params: IHouseGetUserIdReq) {
    return this.http.get<THouseGetUserIdRep>(`${this.url}/house/user/${userId}`, this.authService.getHttpOptions());
  }

  deleteHouseId(houseId: number, params: IHouseDeleteIdReq) {
    return this.http.delete<THouseDeleteIdRep>(`${this.url}/house/${houseId}`, this.authService.getHttpOptions());
  }

  postLavandierQRCode(id: number) {
    return this.http.post(`${this.url}/lavandier/${id}/qrcode`, null, this.authService.getHttpOptions());
  }

  postLavandier(lavandier: ILavandierPostReq) {
    return this.http.post<TLavandierPostRep>(`${this.url}/lavandier`, lavandier, this.authService.getHttpOptions());
  }

  putLavandierQRCodeDisable(id: number) {
    return this.http.put(`${this.url}/lavandier/${id}/qrcode/disable`, null, this.authService.getHttpOptions());
  }

  putLavandier(lavandierId: number, params: ILavandierPutReq) {
    return this.http.put<TLavandierPutRep>(`${this.url}/lavandier/${lavandierId}`, params, this.authService.getHttpOptions());
  }

  getLavandierIdDetails(lavandierId: number) {
    return this.http.get(`${this.url}/lavandier/${lavandierId}/details`, this.authService.getHttpOptions());
  }

  getLavandiers(params?: ILavandierGetReq) {
    return this.http.get<TLavandierGetRep>(`${this.url}/lavandier`, {
      headers: this.authService.getHttpHeaders(), params: new HttpParams({fromObject: params as any}),
    });
  }

  putLight(lightId: number, params: ILightPutIdReq) {
    return this.http.put<TLightPutIdRep>(`${this.url}/light/${lightId}`, params, this.authService.getHttpOptions());
  }

  getLightDetailsList(params: ILightGetDetailsReq) {
    return this.http.get<TLightGetDetailsRep>(`${this.url}/light/details`, this.authService.getHttpOptions());
  }

  getLightBridgeList(params: ILightGetBridgeReq) {
    return this.http.get<TLightGetBridgeRep>(`${this.url}/light/bridge`, this.authService.getHttpOptions());
  }

  getLight(params: ILightGetReq) {
    return this.http.get<TLightGetRep>(`${this.url}/light`, {
      headers: this.authService.getHttpHeaders(),
      // as any is here for retro compatibility with old version of angular
      params: new HttpParams({fromObject: params as any}),
    });
  }

  postNotification(params: { userId: number, messageSMS: string, messageEmail: string }) {
    return this.http.post(`${this.url}/notification`, params, this.authService.getHttpOptions());
  }

  putOrderArticleTrackingDefectIdClose(defectId: number, params: IOrderArticleTrackingPutDefectIdCloseReq) {
    return this.http.put<TOrderArticleTrackingPutDefectIdCloseRep>(`${this.url}/orderarticletracking/defect/${defectId}/close`, params, this.authService.getHttpOptions());
  }

  putOrderArticleTrackingRefStorage(params: IOrderArticleTrackingPutStorageRefReq) {
    return this.http.put<TOrderArticleTrackingPutStorageRefRep>(`${this.url}/orderarticletracking/ref/storage`, params, this.authService.getHttpOptions());
  }

  putOrderArticleTrackingIdUnTidied(id: number, params: IOrderArticleTrackingPutIdUnTidiedReq) {
    return this.http.put<TOrderArticleTrackingPutIdUnTidiedRep>(`${this.url}/orderarticletracking/${id}/untidied`, params, this.authService.getHttpOptions());
  }

  putOrderArticleTrackingIdFactory(id: number, params: IOrderArticleTrackingPutIdFactoryReq) {
    return this.http.put<TOrderArticleTrackingPutIdFactoryRep>(`${this.url}/orderarticletracking/${id}/factory`, params, this.authService.getHttpOptions());
  }

  putOrderArticleTrackingIdDefect(orderArticleTrackingId: number, file: File, params: IOrderArticleTrackingPutIdDefectReq) {
    const uploadFormData = new FormData();
    uploadFormData.append('data', JSON.stringify(params));
    uploadFormData.append('file', file);
    return this.http.put<TOrderArticleTrackingPutIdDefectRep>(`${this.url}/orderarticletracking/${orderArticleTrackingId}/defect`, uploadFormData, this.authService.getHttpOptions());
  }

  putOrderArticleTrackingIdTidied(orderArticleTrackingId: number, params: IOrderArticleTrackingPutIdTidiedReq) {
    return this.http.put<TOrderArticleTrackingPutIdTidiedRep>(`${this.url}/orderarticletracking/${orderArticleTrackingId}/tidied`, params, this.authService.getHttpOptions());
  }

  getOrderArticleTrackingRefDetails(ref: string, params: IOrderArticleTrackingGetRefRefDetailsReq) {
    return this.http.get<TOrderArticleTrackingGetRefRefDetailsRep>(`${this.url}/orderarticletracking/ref/${ref}/details`, this.authService.getHttpOptions());
  }

  postOrderBagOrderArticle(orderBagId: number, file: File, params: { articleId: number, articleOptionIdList: number[], refList: string[], quantity: number, pinColor: string, pinNumber: number }) {
    const uploadFormData = new FormData();
    uploadFormData.append('data', JSON.stringify(params));
    uploadFormData.append('file', file);
    return this.http.post(`${this.url}/orderbag/${orderBagId}/orderarticle`, uploadFormData, this.authService.getHttpOptions());
  }

  putOrderBagStandby(id: number, params: { standby: string }) {
    return this.http.put(`${this.url}/orderbag/${id}/standby`, params, this.authService.getHttpOptions());
  }

  putOrderBagFinish(id: number) {
    return this.http.put(`${this.url}/orderbag/${id}/finish`, null, this.authService.getHttpOptions());
  }

  putOrderBagCheck(id: number) {
    return this.http.put(`${this.url}/orderbag/${id}/check`, null, this.authService.getHttpOptions());
  }

  putOrderBag(id: number, orderBag: IOrderBag) {
    return this.http.put(`${this.url}/orderbag/${id}`, orderBag, this.authService.getHttpOptions());
  }

  getOrderBagTransportSheetRefDetails(params: IOrderBagGetTransportSheetRefDetailsReq) {
    return this.http.get<TOrderBagGetTransportSheetRefDetailsRep>(`${this.url}/orderbag/transportsheet/ref/details`, {
      headers: this.authService.getHttpHeaders(),
      // as any is here for retro compatibility with old version of angular
      params: new HttpParams({fromObject: params as any}),
    });
  }

  getOrderBagNotEmptyDetailsList(params: IOrderBagGetNotEmptyDetailsReq) {
    return this.http.get<TOrderBagGetNotEmptyDetailsRep>(`${this.url}/orderbag/notempty/details`, {
      headers: this.authService.getHttpHeaders(),
      // as any is here for retro compatibility with old version of angular
      params: new HttpParams({fromObject: params as any}),
    });
  }

  getOrderBagRefDetails(ref: string) {
    return this.http.get(`${this.url}/orderbag/ref/${ref}/details`, this.authService.getHttpOptions());
  }

  getOrderBagDetails(id: number) {
    return this.http.get(`${this.url}/orderbag/${id}/details`, this.authService.getHttpOptions());
  }

  deleteOrderBagOrderArticle(id: number, orderArticleId: number) {
    return this.http.delete(`${this.url}/orderbag/${id}/orderarticle/${orderArticleId}`, this.authService.getHttpOptions());
  }

  putOrderShipReturnValidate(id: number, params: IOrderShipReturnPutIdValidateReq) {
    return this.http.put<TOrderShipReturnPutIdValidateRep>(`${this.url}/ordershipreturn/${id}/validate`, params, this.authService.getHttpOptions());
  }

  putOrderShipReturnShip(id: number, params: IOrderShipReturnPutIdShipReq) {
    return this.http.put<TOrderShipReturnPutIdShipRep>(`${this.url}/ordershipreturn/${id}/ship`, params, this.authService.getHttpOptions());
  }

  getOrderShipReturnReadyToValidate(params: IOrderShipReturnGetReadyToValidateReq) {
    return this.http.get<TOrderShipReturnGetReadyToValidateRep>(`${this.url}/ordershipreturn/readytovalidate`, {
      headers: this.authService.getHttpHeaders(),
      // as any is here for retro compatibility with old version of angular
      params: new HttpParams({fromObject: params as any}),
    });
  }

  getOrderShipReturnReadyToShip(params: IOrderShipReturnGetReadyToShipReq) {
    return this.http.get<TOrderShipReturnGetReadyToShipRep>(`${this.url}/ordershipreturn/readytoship`, this.authService.getHttpOptions());
  }

  postOrderIdOrderWantedDelivery(orderId: number, data: { addNoShowOrderLine: boolean, wantedDeliveryDate: string }) {
    return this.http.post(`${this.url}/order/${orderId}/orderwanteddelivery`, data, this.authService.getHttpOptions());
  }

  postOrderIdPay(id: number, params: { paymentType: PaymentType, amount: number, externalId: string }) {
    return this.http.post(`${this.url}/order/${id}/pay`, params, this.authService.getHttpOptions());
  }

  postOrderKit(params: IOrderPostKitReq) {
    return this.http.post<TOrderPostKitRep>(`${this.url}/order/kit`, params, this.authService.getHttpOptions());
  }

  postOrderKitBatch(params: { atHome?: { userId: number, houseId: number }, kitList: { kitId: number, quantity: number }[] }) {
    return this.http.post(`${this.url}/order/kitbatch`, params, this.authService.getHttpOptions());
  }

  postOrderSearch(orderSearch: IOrderSearch) {
    return this.http.post(`${this.url}/order/search`, orderSearch, this.authService.getHttpOptions());
  }

  putOrderIdTransportSheet(orderId: number, params: IOrderPutIdTransportSheetReq) {
    return this.http.put<TOrderPutIdTransportSheetRep>(`${this.url}/order/${orderId}/transportsheet`, null, this.authService.getHttpOptions());
  }

  putOrderIdKitBatch(orderId: number, params: IOrderPutIdKitBatchReq) {
    return this.http.put<TOrderPutIdKitBatchRep>(`${this.url}/order/${orderId}/kitbatch`, params, this.authService.getHttpOptions());
  }

  putOrderIdKit(orderId: number, params: IOrderPutIdKitReq) {
    return this.http.put<TOrderPutIdKitRep>(`${this.url}/order/${orderId}/kit`, params, this.authService.getHttpOptions());
  }

  putOrderIdTransfer(orderId: number) {
    return this.http.put(`${this.url}/order/${orderId}/transfer`, null, this.authService.getHttpOptions());
  }

  putOrderCancel(orderId: number, params: IOrderPutIdCancelReq) {
    return this.http.put<TOrderPutIdCancelRep>(`${this.url}/order/${orderId}/cancel`, params, this.authService.getHttpOptions());
  }

  putOrderIdFinish(id: number) {
    return this.http.put(`${this.url}/order/${id}/finish`, null, this.authService.getHttpOptions());
  }

  getOrderIdOrderArticleTrackingList(orderId: number, params: IOrderGetIdOrderArticleTrackingReq) {
    return this.http.get<TOrderGetIdOrderArticleTrackingRep>(`${this.url}/order/${orderId}/orderarticletracking`, this.authService.getHttpOptions());
  }

  getOrderIdDetails(orderId: number, params: IOrderGetIdDetailsReq) {
    return this.http.get<TOrderGetIdDetailsRep>(`${this.url}/order/${orderId}/details`, this.authService.getHttpOptions());
  }

  getOrderOrderArticleTrackingRefRefDetails(ref: string, params: IOrderGetOrderArticleTrackingRefRefDetailsReq) {
    return this.http.get<TOrderGetOrderArticleTrackingRefRefDetailsRep>(`${this.url}/order/orderarticletracking/ref/${ref}/details`, this.authService.getHttpOptions());
  }

  getOrderReadyToShip(params: IOrderGetReadyToShipReq) {
    return this.http.get<TOrderGetReadyToShipRep>(`${this.url}/order/readytoship`, {
      headers: this.authService.getHttpHeaders(), params: new HttpParams({fromObject: params as any})
    });
  }

  getOrderKitBatch(params: IOrderGetKitBatchReq) {
    return this.http.get<TOrderGetKitBatchRep>(`${this.url}/order/kitbatch`, this.authService.getHttpOptions());
  }

  getOrderKit(params: IOrderGetKitReq) {
    return this.http.get<TOrderGetKitRep>(`${this.url}/order/kit`, this.authService.getHttpOptions());
  }

  getOrderUserHousename(userId: number, params: IOrderGetUserIdHouseNameReq) {
    return this.http.get<TOrderGetUserIdHouseNameRep>(`${this.url}/order/user/${userId}/housename`, {
      headers: this.authService.getHttpHeaders(),
    });
  }

  getOrderUserIdList(userId: number, params: IOrderGetUserIdReq) {
    return this.http.get<TOrderGetUserIdRep>(`${this.url}/order/user/${userId}`, {
      headers: this.authService.getHttpHeaders(), params: new HttpParams({fromObject: params as any}),
    });
  }

  getOrderByPin(pin: string) {
    return this.http.get(`${this.url}/order/pin/${pin}`, this.authService.getHttpOptions());
  }

  getOrderList(params: IOrderGetReq) {
    return this.http.get<TOrderGetRep>(`${this.url}/order`, {
      headers: this.authService.getHttpHeaders(), params: new HttpParams({fromObject: params as any})
    });
  }

  postRole(role: IRole) {
    return this.http.post(`${this.url}/role`, role, this.authService.getHttpOptions());
  }

  putRole(id: number, role: IRole) {
    return this.http.put(`${this.url}/role/${id}`, role, this.authService.getHttpOptions());
  }

  getRole(id: number) {
    return this.http.get(`${this.url}/role/${id}`, this.authService.getHttpOptions());
  }

  getRoleList() {
    return this.http.get(`${this.url}/role`, this.authService.getHttpOptions());
  }

  postShippingPrice(params: { userTypeId: number, type: ShippingPriceType, diff: boolean, start: number, end: number, price: number, orderException: number }) {
    return this.http.post(`${this.url}/shippingprice`, params, this.authService.getHttpOptions());
  }

  putShippingPrice(shippingPriceId: number, params: { type: ShippingPriceType, diff: boolean, start: number, end: number, price: number, orderException: number }) {
    return this.http.put(`${this.url}/shippingprice/${shippingPriceId}`, params, this.authService.getHttpOptions());
  }

  deleteShippingPrice(shippingPriceId: number) {
    return this.http.delete(`${this.url}/shippingprice/${shippingPriceId}`, this.authService.getHttpOptions());
  }

  getStorageUsedList() {
    return this.http.get(`${this.url}/storage/used`, this.authService.getHttpOptions());
  }

  getStorageList(params: IStorageGetReq) {
    return this.http.get<TStorageGetRep>(`${this.url}/storage`, this.authService.getHttpOptions());
  }

  putStorage(params: IStoragePutReq) {
    return this.http.put<TStoragePutRep>(`${this.url}/storage`, params, this.authService.getHttpOptions());
  }

  putTrackingSheetPTLTook(id: number) {
    return this.http.put(`${this.url}/trackingsheet/${id}/ptltook`, null, this.authService.getHttpOptions());
  }

  getTrackingSheetDetails(id: number) {
    return this.http.get(`${this.url}/trackingsheet/details/${id}`, this.authService.getHttpOptions());
  }

  getTrackingSheetDetailsList() {
    return this.http.get(`${this.url}/trackingsheet/details`, this.authService.getHttpOptions());
  }

  getTrackingSheetOrderId(id: number) {
    return this.http.get(`${this.url}/trackingsheet/order/${id}`, this.authService.getHttpOptions());
  }

  getTrackingSheet(id: number) {
    return this.http.get(`${this.url}/trackingsheet/${id}`, this.authService.getHttpOptions());
  }

  putTransportSheetUserIdBook(userId: number, params: ITransportSheetPutUserIdBookReq) {
    return this.http.put<TTransportSheetPutUserIdBookRep>(`${this.url}/transportsheet/user/${userId}/book`, params, this.authService.getHttpOptions());
  }

  putTransportSheetIdFactoryReceived(id: number, params: TTransportSheetPutIdFactoryReceivedReq) {
    return this.http.put<TTransportSheetPutIdFactoryReceivedRep>(`${this.url}/transportsheet/${id}/factoryreceived`, null, this.authService.getHttpOptions());
  }

  putTransportSheetIdFactorySent(id: number, params: TTransportSheetPutIdFactorySentReq) {
    return this.http.put<TTransportSheetPutIdFactorySentRep>(`${this.url}/transportsheet/${id}/factorysent`, null, this.authService.getHttpOptions());
  }

  putTransportSheetIdDisable(id: number, params: ITransportSheetPutIdDisableReq) {
    return this.http.put<TTransportSheetPutIdDisableRep>(`${this.url}/transportsheet/${id}/disable`, params, this.authService.getHttpOptions());
  }

  putTransportSheetIdHouse(id: number, params: ITransportSheetPutIdHouseReq) {
    return this.http.put<TTransportSheetPutIdHouseRep>(`${this.url}/transportsheet/${id}/house`, params, this.authService.getHttpOptions());
  }

  getTransportSheetUserId(userId: number, params: TTransportSheetGetUserIdReq) {
    return this.http.get<TTransportSheetGetUserIdRep>(`${this.url}/transportsheet/user/${userId}`, this.authService.getHttpOptions());
  }

  getTransportSheetRefDetails(params: ITransportSheetGetRefDetailsReq) {
    return this.http.get<TTransportSheetGetRefDetailsRep>(`${this.url}/transportsheet/ref/details`, {
      headers: this.authService.getHttpHeaders(),
      // as any is here for retro compatibility with old version of angular
      params: new HttpParams({fromObject: params as any}),
    });
  }

  getTransportSheetIdRePrint(id: number, params: ITransportSheetGetIdRePrintReq) {
    return this.http.get<TTransportSheetGetIdRePrintRep>(`${this.url}/transportsheet/${id}/reprint`, this.authService.getHttpOptions());
  }

  postUpload(upload: IUpload) {
    const uploadFormData = new FormData();
    uploadFormData.append('folder', upload.folder.toString());
    uploadFormData.append('file', upload.file);
    return this.http.post(`${this.url}/upload`, uploadFormData, this.authService.getHttpOptions());
  }

  getUpload(uploadId: number) {
    return this.http.get(`${this.url}/upload/${uploadId}`, {
      headers: this.authService.getHttpHeaders(),
      responseType: 'blob',
    });
  }

  postUserType(userType: { parentUserTypeId: number, name: string, important: number, noShowException: number, noShowPrice: number, storageException: number, storagePrice: number, storageDeadLine: number, storageDeadLineEvent1: number, storageDeadLineEvent2: number, configInvoiceTemplate: ConfigInvoiceTemplate }) {
    return this.http.post(`${this.url}/user/type`, userType, this.authService.getHttpOptions());
  }

  postUser(params: IUserPostReq) {
    return this.http.post<TUserPostRep>(`${this.url}/user`, params, this.authService.getHttpOptions());
  }

  putUserIdForgottenPassword(userId: number, params: IUserPutIdForgottenPasswordReq) {
    return this.http.put<TUserPutIdForgottenPasswordRep>(`${this.url}/user/${userId}/forgottenpassword`, params, this.authService.getHttpOptions());
  }

  putUserIdAnonymiseCancel(userId: number, params: IUserPutIdAnonymiseCancelReq) {
    return this.http.put<TUserPutIdAnonymiseCancelRep>(`${this.url}/user/${userId}/anonymise/cancel`, params, this.authService.getHttpOptions());
  }

  putUserType(userTypeId: number, userType: { parentUserTypeId: number, name: string, fakePayment: boolean, important: number, noShowException: number, noShowPrice: number, storageException: number, storagePrice: number, storageDeadLine: number, storageDeadLineEvent1: number, storageDeadLineEvent2: number }) {
    return this.http.put(`${this.url}/user/type/${userTypeId}`, userType, this.authService.getHttpOptions());
  }

  putUserIdEnabled(userId: number, data: { enabled: boolean }) {
    return this.http.put(`${this.url}/user/${userId}/enabled`, data, this.authService.getHttpOptions());
  }

  putUser(userId: number, userEdit: IUserEdit) {
    return this.http.put(`${this.url}/user/${userId}`, userEdit, this.authService.getHttpOptions());
  }

  deleteUser(userId: number, params: IUserDeleteIdReq) {
    return this.http.delete<TUserDeleteIdRep>(`${this.url}/user/${userId}`, this.authService.getHttpOptions());
  }

  getUserIntercomConversation(userId: number) {
    return this.http.get(`${this.url}/user/intercom/conversation/${userId}`, this.authService.getHttpOptions());
  }

  getUserIntercomRedirect(userId: number, params: IUserGetIntercomRedirectByUserIdReq) {
    return this.http.get<TUserGetIntercomRedirectByUserIdRep>(`${this.url}/user/intercom/redirect/${userId}`, this.authService.getHttpOptions());
  }

  getUserTypeDetailsList() {
    return this.http.get(`${this.url}/user/type/details`, this.authService.getHttpOptions());
  }

  getUserType(userTypeId: number) {
    return this.http.get(`${this.url}/user/type/${userTypeId}`, this.authService.getHttpOptions());
  }

  getUserTypeList(params: IUserGetTypeReq) {
    return this.http.get<TUserGetTypeRep>(`${this.url}/user/type`, this.authService.getHttpOptions());
  }

  getUser(userId: number) {
    return this.http.get(`${this.url}/user/${userId}`, this.authService.getHttpOptions());
  }

  getUserList(params?: { id?: string, userTypeId?: string, email?: string, name?: string, phoneNumber?: string, createdAt?: string }, page?: StringPage) {
    return this.http.get(`${this.url}/user`, {
      headers: this.authService.getHttpHeaders(), params: {...params, ...page},
    });
  }
}
